import { useEffect, useState } from 'react';
import { getProfileStats } from '../../services/ProfileStatsServices';
import styles from './styles/ProfileStats.module.css';


const ProfileStats = ({ creatorId }) => {
    const [profileStats, setProfileStats] = useState(null);
    const [error, setError] = useState(false);

    useEffect(() => {
        const fetchProfileStats = async () => {
            if (!creatorId) { // If no creatorID, return
                return;
            }

            try { // Get profile stats (scenario count, total views, avg rating)
                setError(false);
                const data = await getProfileStats(creatorId);
                setProfileStats(data);
            } catch (err) {
                console.error('Error fetching profile stats:', err);
                setError(true);
            }
        };

        fetchProfileStats();
    }, [creatorId]); // Fetch profile stats whenever creator profile changes

    // Don't render fake zeros while loading or when the fetch failed
    const loading = profileStats === null && !error;
    const display = (value) => {
        if (loading || error) return "–";
        return value;
    };

    return (
        <div className={styles.profileStats}>

            <div className={styles.stat}>
                <div className={styles.statBox}>
                    {display(profileStats?.scenarioCount ?? 0)}
                </div>
                <span className={styles.statLabel}>Scenarios</span>
            </div>

            <div className={styles.stat}>
                <div className={styles.statBox}>
                    {display((profileStats?.totalViews ?? 0).toLocaleString())}
                </div>
                <span className={styles.statLabel}>Total Views</span>
            </div>

            <div className={styles.stat}>
                <div className={styles.statBox}>
                    {display(`${(profileStats?.averageRating ?? 0).toFixed(1)} ★`)}
                </div>
                <span className={styles.statLabel}>Avg. Rating</span>
            </div>

            {error && <span className={styles.statsError}>Stats unavailable</span>}

        </div>
    );
};

export default ProfileStats;
